module.exports = __webpack_public_path__ + "09685e36847d4cf4d4ab40bf578fa13d.jpg";